export default x => () => x;



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-contour/src/constant.js
// module id = 284
// module chunks = 0